var _defs, _circle, _circle2, _path, _circle3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgNumeros09(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d9d9d8;}.cls-2{fill:#00408a;}.cls-3{opacity:0.6;fill:url(#Degradado_sin_nombre_10);}.cls-4{fill:url(#Degradado_sin_nombre_27);}.cls-5{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10",
    x1: 10,
    y1: 1.32,
    x2: 10,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fff",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_27",
    cx: 10,
    cy: 9.71,
    r: 8.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#acacac",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NUMEROS_1_5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10,
    cy: 9.71,
    r: 9.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10,
    cy: 9.71,
    r: 8.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.4,9.71c0,4.64-3.16-1.19-7.8-1.19s-9,5.83-9,1.19a8.4,8.4,0,0,1,16.8,0Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 10,
    cy: 9.71,
    r: 8.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13.16,9.28a3.18,3.18,0,0,1,1.19,2.61,3.48,3.48,0,0,1-2.07,3.25,5.89,5.89,0,0,1-2.55.49,8.12,8.12,0,0,1-2.41-.35,5.92,5.92,0,0,1-2-1l.91-1.68a5,5,0,0,0,1.56.84,5.9,5.9,0,0,0,1.87.3,3,3,0,0,0,1.81-.47A1.53,1.53,0,0,0,12.17,12a1.5,1.5,0,0,0-.71-1.35A4.65,4.65,0,0,0,9,10.16H6.22l.6-6.35h6.84V5.63h-5L8.4,8.33H9.52A5.78,5.78,0,0,1,13.16,9.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumeros09);
export default __webpack_public_path__ + "static/media/NUMEROS09.a324702c22f2d3f74e62de72b98b503f.svg";
export { ForwardRef as ReactComponent };